var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "no-click-animation": "",
      "persistent": "",
      "width": "500",
      "transition": false
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('profile.actionReq')) + " ")]), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.$t('profile.fillProfileProcess')) + " ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "outlined": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.go();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.gotoProfile')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }